import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import jsLang from '../lib/jslang';
import TableItem from '../models/TableItem';
import TableHeader from '../models/TableHeader';
import PaginatedTableComponent from '../components/ui/PaginatedTable';
import LoadingButton from './ui/LoadingButton';

export class InstallationsImportPreview extends Component {
    /**
     * Component constructor.
     *
     * @param {Object} props
     */
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    /**
     * Returns the payload for the post requests.
     *
     * @return {Object}
     */
    getPayload() {
        const {
            rows,
        } = this.props;

        const orders = [];

        rows.forEach(row => {
            const order = {};

            row.forEach(item => {
                Object.assign(order, {
                    [item.attribute]: item.value,
                });
            });

            orders.push(order);
        });

        return {
            orders,
        };
    }

    /**
     * Checks if the order items have any errors.
     *
     * @return {Boolean}
     */
    areRowsValid() {
        const {
            rows,
        } = this.props;

        const rowsWithError = rows.filter(row => (row.filter(tableCell => (tableCell.hasError)).length > 0));

        return rowsWithError.length === 0 && rows.length > 0;
    }

    /**
     * Handles cancel event, redirects client to specified cancel url.
     *
     * @return {void}
     */
    handleCancel() {
        window.location.assign(this.props.cancelUrl);
    }

    /**
     * Handles submit event, to send orders to API.
     *
     * @return {void}
     */
    handleSubmit() {
        this.setState({
            loading: true,
        });

        const url = this.props.submitUrl;
        const payload = this.getPayload();

        axios.post(url, payload).then(() => {
            this.setState({
                loading: false,
            });

            window.location.assign(this.props.successUrl);
        }).catch(error => {
            alert(jsLang.get('orders.form.error'));

            this.setState({
                loading: false,
            });

            if (error instanceof Error) {
                throw error;
            }
        });
    }

    /**
     * Renders the component.
     *
     * @return {JSX}
     */
    render() {
        const {
            rows,
            headers,
        } = this.props;

        const {
            loading,
        } = this.state;

        return (
            <PaginatedTableComponent
                id="installations-import-preview"
                className="table--order-import-preview"
                rows={ rows }
                headers={ headers }
            >
                <p className="font-size-sm">
                    { jsLang.get('orders.preview.note') }
                </p>

                <div className="btn-group">
                    <button
                        id="cancel-button"
                        disabled={ loading }
                        className="btn btn--tertiary"
                        onClick={ this.handleCancel }
                    >
                        { jsLang.get('buttons.cancel') }
                    </button>

                    <LoadingButton
                        id="submit-button"
                        className="btn btn--primary"
                        disabled={ !this.areRowsValid() }
                        text={ jsLang.get('buttons.submit') }
                        isLoading={ loading }
                        onClick={ this.handleSubmit }
                    />
                </div>
            </PaginatedTableComponent>
        );
    }
}

InstallationsImportPreview.propTypes = {
    rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape(TableItem))).isRequired,
    headers: PropTypes.arrayOf(PropTypes.shape(TableHeader)).isRequired,
    cancelUrl: PropTypes.string.isRequired,
    submitUrl: PropTypes.string.isRequired,
    successUrl: PropTypes.string.isRequired,
};

InstallationsImportPreview.defaultProps = {};

export const mapStateToProps = state => ({
    rows: state.rows,
    headers: state.headers,
});

export default connect(mapStateToProps)(InstallationsImportPreview);
